export default <T = unknown>(query: string, params = {}) => {
  return useSanityQuery<T>(query, {
    language: useNuxtApp().$i18n.locale,
    ...params,
  })
}
